import React from "react";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";
import { SectionHeader } from "../../components/section-header.tsx";
import { Tabs } from "../../components/tabs/tabs.tsx";
import { MortgageCalculator } from "./mortgage-calculator.tsx";
import { PaymentCalculator } from "./payment-calculator.tsx";
import { LBTTCalculator } from "./lbtt-calculator.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { ButtonLink } from "../../components/buttons/button-link.tsx";
interface CalculatorProps {
  price: number;
}

const mortgage = (
  <>
    <span>Mortgage</span>
    <span className="hidden md:inline">&nbsp;calculator</span>
  </>
);
const payment = (
  <>
    <span>Payment</span>
    <span className="hidden md:inline">&nbsp;calculator</span>
  </>
);
const lbtt = (
  <>
    <span>LBTT</span>
    <span className="hidden md:inline">&nbsp;calculator</span>
  </>
);
export const Calculators: React.FC<CalculatorProps> = ({ price }) => {
  return (
    <div className={"flex flex-col gap-3 md:gap-3.5"}>
      <SectionHeader text={"Useful calculators"} as={"h2"} className={FontStyles.h5} />
      <Tabs labels={[mortgage, payment, lbtt]}>
        <MortgageCalculator price={price} />
        <PaymentCalculator />
        <LBTTCalculator price={price} />
      </Tabs>
      <ButtonLink
        href="/services/mortgages"
        label="Get mortgage advice"
        colorVariant="secondary"
        variant="outlined"
        renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-coins" />}
      />
    </div>
  );
};
